import React from 'react';

export const FlagUSIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 380 200" // Standard 19:10 ratio
    {...props}
  >
    <defs>
      <path id="star" d="M0 -10 L2.939 -4.045 L9.511 -3.09 L4.755 1.18 L5.878 7.045 L0 4 L-5.878 7.045 L-4.755 1.18 L-9.511 -3.09 L-2.939 -4.045 Z" fill="#FFFFFF"/>
    </defs>
    <rect width="380" height="200" fill="#FFFFFF" rx="2"/> {/* White base for stripes */}
    {/* 7 Red Stripes */}
    {[0,1,2,3,4,5,6].map(i => (
      <rect key={`red-${i}`} y={(i * 200/13) * 2} width="380" height={200/13} fill="#B22234"/>
    ))}
    <rect width="152" height={200 * (7/13)} fill="#3C3B6E" /> {/* Blue canton (7/13 of height) */}
    {/* Simplified star pattern (5 rows of 4 stars, 4 rows of 3 stars - total 32 for icon simplicity) */}
    {[...Array(5)].map((_, r) =>
      [...Array(4)].map((_, c) => (
        <use key={`star-r1-${r}-${c}`} href="#star" transform={`translate(${18 + c * 35}, ${15 + r * (200 * (7/13) / 6)}) scale(0.7)`} />
      ))
    )}
     {[...Array(4)].map((_, r) =>
      [...Array(3)].map((_, c) => (
        <use key={`star-r2-${r}-${c}`} href="#star" transform={`translate(${18 + 17.5 + c * 35}, ${15 + (200*(7/13)/12) + r * (200 * (7/13) / 6)}) scale(0.7)`} />
      ))
    )}
  </svg>
);